import { create } from 'zustand';
import { CartStore } from '../types/shopping';
import { MethodWay } from '../utils/common';

const useCartStore = create<CartStore>((set) => ({
  shoppingItems: {},
  setShoppingItems: (items) => set({ shoppingItems: items }),
  paymentMethod: MethodWay.BC,
  setPaymentMethod: (method) => set({ paymentMethod: method }),
}));

export default useCartStore;
